import { Component, OnInit } from '@angular/core';
import { UploadService } from 'src/app/services/upload/upload.service';
import { DETAIL_COL_DEFINITION } from './config/col-definition';
import { TokenService } from 'src/app/services/token/token.service';
import { LoginInfo } from 'src/app/shared/models';
import * as jose from 'jose';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/services/session/session.service';
@Component({
    selector: 'app-upload-summary',
    templateUrl: './upload-summary.component.html',
    styleUrls: ['./upload-summary.component.css'],
    standalone: false
})
export class UploadSummaryComponent implements OnInit {

  columnDefs = DETAIL_COL_DEFINITION;
  filterFileTypes: string[] = []

  filteredRowData: any[] = [];
  displayRowData: any[] = [];
  errorMsg = ''
  loading = true

  private originalRowData: any = null
  private currentFilterParams: any = null
  private paginationParam = {
    pageSize: 10,
    startIndex: 0
  }

  constructor(private upload: UploadService,private token: TokenService,private router: Router,private session: SessionService,) { }

  ngOnInit(): void {
    this.loading = true
    this.errorMsg = ''
  
      const info: LoginInfo = jose.decodeJwt(this.token.getAccessToken());
      let isInternal = info['isinternal'] === "true" ? true : false;
      const res = String(this.session.getItem('isTransDataRestricted'));
      let isTransDataRestricted = res === "true" ? true : false;
      if (isInternal) {
        if(!isTransDataRestricted){
         // Set default date values
        const today = new Date();
        const sixMonthsAgo = new Date();
        sixMonthsAgo.setMonth(today.getMonth() - 6);

        // Call the API with default date values
        this.currentFilterParams = {
          case_number: '',
          filename: '',
          filetype: '',
          masked_filename: '',
          startDate: this.formatDate(sixMonthsAgo),
          endDate: this.formatDate(today)
        };
        this.fetchUploadSummary(this.currentFilterParams);
      }else{
        this.router.navigate(['/accessDenied']);
      }
      } else {
        this.router.navigate(['/']);
      }
    
  }
  
  fetchUploadSummary(param?: any): void {
    this.loading = true;
    this.upload.getUploadSummary(param).subscribe({
      next: (res) => {
        this.originalRowData = res;
        this.filteredRowData = res; // Set filteredRowData to the fetched data
        this.pupulateFilteTypes();
        this.columnDefs = this.buildColumnDefinitions(res); // Set columnDefs here
        this.loading = false;
        this.applyPagination(this.paginationParam)
      },
      error: () => {
        this.errorMsg = 'sfu_upload_summary_error';
        this.loading = false;
      }
    });
  }

  filterData(param: any): void {
    // Reset pagination to first page when filtering
    this.paginationParam = {
      pageSize: 10,
      startIndex: 0
    }
    // Store current filter parameters
    this.currentFilterParams = param;
    // Call the API with filter parameters instead of filtering locally
    this.fetchUploadSummary(param);
  }

  applyPagination(param: any): void {
    this.displayRowData = this.filteredRowData.slice(param.startIndex, param.startIndex + param.pageSize)
  }

  handleLambdaTrigger(row: any): void {
    console.log('Triggering lambda for row:', row);
    const payload = {
      masked_file_name: row.masked_file_name,
      case_number: row.case_number,
      osversion: row.os_version,
      file_type: row.file_type,
      filename: row.filename
    }
    
    this.loading = true
    this.upload.triggerLambda(payload).subscribe({
      next: (response) => {
        this.loading = false
        // alert('Lambda triggered successfully!')
        // Optionally refresh the data with current filter parameters
        this.fetchUploadSummary(this.currentFilterParams)
      },
      error: (error) => {
        this.errorMsg = 'sfu_lambda_trigger_error';
        this.loading = false
        // alert('Failed to trigger lambda: ' + (error?.error?.message || 'Unknown error'))
      }
    })
  }

  private pupulateFilteTypes(): void {
    const fileTypesMap = this.originalRowData.reduce((map: any, row: any) => {
      map[row.fileType] = true
      return map
    }, {})
    this.filterFileTypes = Object.keys(fileTypesMap)
  }
  private buildColumnDefinitions(data: any[]): any[] {
    const hasUserId = data.some(row => row.userId);

    const colDefs = [...DETAIL_COL_DEFINITION]
    if (hasUserId) {
      colDefs.unshift({
        headerName: 'User ID',
        field: 'userId',
      })
    }
    return colDefs
  }
private formatDate(date: Date): string {
    // Format the date to YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
